import React, { useEffect, useState } from 'react';
import './App.css';
import BookingPage from './BookingPage';
import IntroSplash from './IntroSplash';

const SPLASH_TOTAL_MS = 3600;
const SPLASH_FADE_OUT_MS = 1400;
const SPLASH_FADE_START_MS = Math.max(0, SPLASH_TOTAL_MS - SPLASH_FADE_OUT_MS);

function App() {
  const shouldShowSplash = process.env.NODE_ENV !== 'test';
  const [splashPhase, setSplashPhase] = useState(shouldShowSplash ? 'visible' : 'hidden');

  useEffect(() => {
    if (splashPhase === 'hidden') return undefined;

    const fadeTimer = window.setTimeout(() => setSplashPhase('fading'), SPLASH_FADE_START_MS);
    const hideTimer = window.setTimeout(() => setSplashPhase('hidden'), SPLASH_TOTAL_MS);

    return () => {
      window.clearTimeout(fadeTimer);
      window.clearTimeout(hideTimer);
    };
  }, [splashPhase]);

  const showSplash = splashPhase !== 'hidden';
  const fadeOutSplash = splashPhase === 'fading';

  return (
    <div className="AppShell">
      <BookingPage />
      {showSplash && (
        <IntroSplash className={fadeOutSplash ? 'IntroSplash--fadeOut' : ''} />
      )}
    </div>
  );
}

export default App;
